import { Component,ViewEncapsulation, OnInit,OnDestroy } from '@angular/core';
import { Http } from '@angular/http';
import * as moment from 'moment/moment';
import {CsvService} from 'angular2-json2csv';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe, PipeTransform} from '@angular/core';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
declare  const $;
import { Popup } from 'ng2-opd-popup';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit {
	loadingpieDataSource:boolean=false;
	loadingdataSource:boolean=false;
	loadingdataSource1:boolean=false;
	loadingdatavalues:boolean=false;
	loadingLabourTravelHours:boolean=false;
	pieDataSource=[]
	dataSource1=[];
	dataSource=[];
	datavalues=[];
  	ListAlldueDates = [];
	datavalue = [];
	comdataValue = [];
	datalabel = [];
	label = [];
	ListServiceDueDetails = []
	Days:number= moment().daysInMonth();
	Month:string = moment().format('MMM YYYY');
	partCost:number = 0;
	labourCost:number = 0;
	LabourHours:number=0;
	TravelHours:number=0;
	travelCost:number = 0;
	serviceValues:number;
	labourValues:number;
	ConsumablesValue:number;
	TravelLabourHours:number=0;
	serviceMax:number;
	partValues:number=0;
	AlabourtargetValue:any = 0;
	AtravelLabourTargetHours=0;
	AparttargetValue:any = 0;
	AfromDate;
	AtoDate;
	FfromDate;
	FtoDate;
	ApartCost:number;
	interval: any;
	gaugeType = "semi";
    gaugeLabel = "Speed";
    gaugeAppendText = "km/hr";
    red = 'red';
    green = 'green';
  
    clickFCount:number = 0;
    clickACount:number = 0;
    serviceType = [];
    ListSerialnumber = [];
    ListServiceType = [];
    ListFinalServiceTypeValue = [];
    Svalue = [];
    SCvalue = [];
    piechardata1 = [];
    SpareCost=0;
    Consuamble=0;
    ListPartDetails = [];
    ListSpareDetails = [];
    barcolor = [];
    month:any;
	currentStartDate:any;
	currentEndDate:any;
	orgId:number;
  	userId:number; 
  	spedoConsumables:number=0;
  	spedoLabour:number=0;
  	ListFinalCompletedServiceType=[];
	LabourTravelHours = [];
	listAllCompletedService = [];
  
  	barChartLabels1 = [];
    
    barChartLabels = [];
	pieChartLabels = ['Labour Cost', 'Travel Cost', 'Spare Cost', 'Consumable Cost'];
  	pieChartLabels1 = [];
  	// public pieChartData:number[] = [];
  	// public pieChartLabourtravelData:number[] = [];
  	public pieChartData1:number[] = [];
  	pieChartLabourTravelHours = ['Labour Hours', 'Travel Hours'];  
  	constructor(private http: Http,private csvService: CsvService,private router:Router,private route : ActivatedRoute) { 
  		
	   
	}


    ngOnInit() {
		this.loadingdataSource=true;
		this.loadingpieDataSource=true;
		this.loadingdataSource1=true;
		this.loadingdatavalues=true;
		this.loadingLabourTravelHours=true;
    	if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	       window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      // console.log('OrgId '+ this.orgId);
	      // console.log('UserId '+ this.userId);
		}
		this.getthisMonthData();
  	    this.getServiceDetail();
  	    this.getServiceTypeDetails();
  	    this.getLabourCostANDConsumables();

  	}
  	
	

	getServiceTypeDetails() {
		this.barChartLabels = [];
		this.serviceType = [];
		this.barChartLabels = [];
		this.pieChartLabels1 = [];
		this.ListServiceType = [];
		let serviceObj ={
			'orgId':this.orgId
		}
		return this.http.post('/api/getServiceTypedetails',serviceObj).subscribe(
	    	res=>{  
	    		let STRepsonse = res.json();
	    		this.ListServiceType = res.json();
	    		for(let st=0;st<STRepsonse.length;st++) {
					this.serviceType.push(STRepsonse[st].servicetype);
					this.piechardata1.push(0);
	    		}
	    		this.barChartLabels = this.serviceType;
				this.pieChartLabels1 = this.serviceType;
				//console.log("pieChartLabels1",this.pieChartLabels1)

	    },(err)=>{
	    	console.log(err);
	    })
	}



 	customizeLabel(point) {
 		return point.argument +' : '+ point.originalValue;
    }

    customizeTooltip(arg: any) {
     	return {
            text: "DATE :"+arg.argument+ " " +arg.seriesName + ' : ' + arg.valueText
        }; 
	}
	
	customizeTooltip1(arg: any){
		
		return {
            text: "ServiceType :"+arg.argument+ " ," +arg.seriesName + ' : ' + arg.valueText
        }; 
	}

	exportToExcelConsumable(event) {
		let consumable = [];
		let conObj = {};
		for(let i=0;i<this.ListPartDetails.length;i++) {
			conObj = {
				'S_NO':i+1,
				'PART_NUMBER':this.ListPartDetails[i].part_Number,
				'DESCRIPTION':this.ListPartDetails[i].descriptions,
				'QUANTITY':this.ListPartDetails[i].quantity,
				'COST_TYPE':this.ListPartDetails[i].cost_Type
			}
			consumable.push(conObj);
		}
		let Reportstartdate = moment(this.FfromDate).format('D MMM YYYY');
		let Reportenddate = moment(this.FtoDate).format('D MMM YYYY');
	    this.csvService.download(consumable, Reportstartdate+ ' to '+ Reportenddate+'Consuambales Details');
	}

	exportToExcelSpare(event) {
		let spare = [];
		for(let i=0;i<this.ListSpareDetails.length;i++) {
			let conObj = {
				'S_NO':i+1,
				'PART_NUMBER':this.ListSpareDetails[i].part_Number,
				'DESCRIPTION':this.ListSpareDetails[i].descriptions,
				'QUANTITY':this.ListSpareDetails[i].quantity,
				'COST_TYPE':this.ListSpareDetails[i].cost_Type
			}
			spare.push(conObj);
		}
		let Reportstartdate = moment(this.FfromDate).format('D MMM YYYY');
		let Reportenddate = moment(this.FtoDate).format('D MMM YYYY');
		this.csvService.download(spare, Reportstartdate+ ' to '+ Reportenddate+'Spares Details');
	}

	forcasttodate(date) {
		if(date < this.FfromDate) {
			alert('Forecast To date should be greater than Forecast From date');
			this.FtoDate = '';
		}
	}

	Achtodate(date) {
		if(date < this.AfromDate) {
			alert('Achievement To date should be greater than Achievement From date');
			this.AtoDate = '';
		}
	}

	forcastreport() {
		this.clickFCount =1;
		this.datavalue = [];
		this.comdataValue = [];
		this.datalabel = [];
		this.serviceType = [];
		this.barChartLabels1 = [];
		this.pieChartData1 = [];
		// this.pieChartData = [];
		// this.pieChartLabourtravelData=[];
		this.pieChartLabels = [];
		this.piechardata1 = [];
		this.pieChartLabels1 = [];
		this.datalabel = [];
		this.getServiceTypeDetails();
		this.getthisMonthData();
	}

    changeMonth(month) {
		this.loadingLabourTravelHours=true;
		this.loadingdataSource=true;
		this.loadingdataSource1=true;
		this.loadingdatavalues=true;
		this.loadingpieDataSource=true;
		this.clickFCount=1;
		var date = new Date(), y = date.getFullYear();
		let firstDay = new Date(y, month-1, 1);
		let lastDay = new Date(y, month, 0);
		this.currentStartDate = moment(firstDay).format('YYYY-MM-DD');
		this.currentEndDate = moment(lastDay).format('YYYY-MM-DD');
		this.FfromDate = moment(firstDay).format('YYYY-MM-DD');
		this.FtoDate = moment(lastDay).format('YYYY-MM-DD');
		this.AfromDate=moment(firstDay).format('YYYY-MM-DD');
		this.AtoDate=moment(lastDay).format('YYYY-MM-DD');
		this.datavalue = [];
		this.comdataValue = [];
		this.datalabel = [];
		this.serviceType = [];
		this.barChartLabels1 = [];
		this.pieDataSource=[];
		this.ListSpareDetails=[];
		this.ListPartDetails=[];
		// this.pieChartLabourtravelData=[];
		this.pieChartLabels = [];
		this.datalabel = [];
		this.dataSource = [];
		this.dataSource1 = [];
		this.getServiceTypeDetails();
		this.getthisMonthData();
		//this.getLabourCostANDConsumables();
		this.achReport();
	}

 	getthisMonthData() {
 		this.datalabel = [];
 		this.datavalue = [];
 		this.comdataValue = [];
 		this.Svalue = [];
 		this.ListServiceDueDetails = [];
		this.ListSerialnumber = [];
		this.ListAlldueDates = [];
		this.piechardata1 = [];
		this.barChartLabels1=[];//////
		this.ListFinalServiceTypeValue = [];
 		let RequiredObj = {};
 		if(this.clickFCount == 0) {
 			var date = new Date(), y = date.getFullYear(), m = date.getMonth();
			let firstDay = new Date(y, m, 1);
			let lastDay = new Date(y, m + 1, 0);
			this.month = m+1;
			let firstDate = moment(firstDay).format('YYYY-MM-DD');
			let lastDate = moment(lastDay).format('YYYY-MM-DD');
			this.currentStartDate = moment(firstDay).format('YYYY-MM-DD');
			this.currentEndDate = moment(lastDay).format('YYYY-MM-DD');
		  	RequiredObj = {
		      'fromDate': moment(firstDate).format('YYYY-MM-DD'),
		      'toDate':moment(lastDate).add(1, 'days').format('YYYY-MM-DD'),
		      'orgId':this.orgId
		    }
		    for(var d=parseInt(moment(firstDate).format('DD'));d<=parseInt(moment(lastDate).format('DD'));d++) {
				this.datalabel.push(d);
			}
			let _lineChartLabel:Array<any> = new Array(this.barChartLabels1);
			this.barChartLabels1 = this.datalabel;
		    this.FfromDate = firstDate;
			this.FtoDate = lastDate;
 		} else if(this.clickFCount == 1) {
 			RequiredObj = {
		      'fromDate': moment(this.FfromDate).format('YYYY-MM-DD'),
		      'toDate':moment(this.FtoDate).add(1, 'days').format('YYYY-MM-DD'),
		      'orgId':this.orgId
		    }
		    for(var d=parseInt(moment(this.FfromDate).format('DD'));d<=parseInt(moment(this.FtoDate).format('DD'));d++) {
				this.datalabel.push(d);
			}
			let _lineChartLabel:Array<any> = new Array(this.barChartLabels1);
			this.barChartLabels1 = this.datalabel;
			this.clickFCount=0;
 		}
	  	

		
		return this.http.post('/api/getFourMonthServiceDetailsForInactive', RequiredObj).subscribe(
		    res=>{ 

		    this.listAllCompletedService = [];	
		    this.ListServiceDueDetails = [];	
		    this.ListAlldueDates = [];
		    this.ListSerialnumber =[];
		    this.label = [];
			this.datavalue = [];
			this.comdataValue = [];
	    	let response = res.json();
	    	this.ListServiceDueDetails = res.json();
	    	for(var i=0;i<response.length;i++) {
	    		if(this.ListServiceDueDetails[i].status == 1) {
	    			this.listAllCompletedService.push(response[i].service_CarriedOut_Date);
	    		}
	    		let dueObj = {
	    			'date':response[i].service_CarriedOut_Date,
	    		}
	    		this.ListSerialnumber.push(response[i].serialNumber);
	    		this.ListAlldueDates.push(response[i].service_CarriedOut_Date);
	    	}
	    	var  count = {};
	    	var completed = {};
		    this.ListAlldueDates.forEach(function(i) { count[i] = (count[i]||0) + 1;});
		    this.listAllCompletedService.forEach(function(i) { completed[i] = (completed[i]||0) + 1;});
		    //console.log(count);
		    //	let key = Object.keys(count);
		    //for due service details
		    let key=[];
			let value=[];
		    let arr = [];
		    arr.push(count);
			arr.forEach(function(item){
 
			  for(let i in item)
			  {
			    key.push(i);
			    value.push(item[i]);
			  }
			   
			});
			let labeldata:string;
			let insert=0;
			
			for(let k=0;k<this.Days;k++) {
		    	let nowdate = moment(this.FfromDate).add(k, 'days').format('YYYY-MM-DD');
		    	for(let m=0;m<key.length;m++) {
		    		if(nowdate == key[m]) {
		    			insert=1;
		    			let keyname = parseInt(key[m]);
		    			labeldata = moment(nowdate).format('DD');
		    			this.label.push(labeldata);
		    			this.datavalue.push(value[m]);
		    		} else {
		    			
		    		}
		    	}
		    	if(insert == 0) {
		    		labeldata = moment(nowdate).format('DD');
		    		this.label.push(labeldata);
		    		this.datavalue.push(0);
		    	} else {
		    		insert=0;
		    	}
		    }
		    //for completed service details
		    let comkey=[];
			let comvalue=[];
		    let comarr = [];
		    comarr.push(completed);
			comarr.forEach(function(item){
 
			  for(let i in item)
			  {
			    comkey.push(i);
			    comvalue.push(item[i]);
			  }
			   
			});
			let comlabeldata:string;
			let cominsert=0;
			
			for(let k=0;k<this.Days;k++) {
		    	let nowdate = moment(this.FfromDate).add(k, 'days').format('YYYY-MM-DD');
		    	for(let m=0;m<comkey.length;m++) {
		    		if(nowdate == comkey[m]) {
		    			cominsert=1;
		    			let keyname = parseInt(comkey[m]);
		    			this.comdataValue.push(comvalue[m]);
		    		} else {}
		    	}
		    	if(cominsert == 0) {
		    		this.comdataValue.push(0);
		    	} else {
		    		cominsert=0;
		    	}
		    }
         
    		//console.log("DATASOURCE ",this.dataSource)

		    this.dataSource = [];
		   
		    	for(let i=0;i<this.label.length;i++) {
      		
	      			if(this.datavalue[i] == 0 && this.comdataValue[i] ==0) {

	      			} else {
	      				 let obj = {
		    				'day':this.label[i],
		    			    'due':this.datavalue[i]-this.comdataValue[i],
		    				'com':this.comdataValue[i]
		    			}
		   				this.dataSource.push(obj);
	      			}
	   			}
		    this.loadingdataSource=false;
      		
   			//console.log("DATASOURCE ",this.dataSource)

		    let reqObj = {
		  		'data':this.ListSerialnumber
		  	}
		  	return this.http.post('/api/getPostPonedReportBasedOnSerialNumber', reqObj).subscribe(
		    res=>{ 
		   
		    	this.ListPartDetails = [];
		    	this.ListFinalCompletedServiceType = [];
	    		let SRResponse = res.json();
	    		for(let sr=0;sr<SRResponse.length;sr++) {
	    			for(let pt=0;pt<SRResponse[sr].Sparedetails.length;pt++) {
	    				if(SRResponse[sr].Sparedetails[pt].cost_Type == 'CONSUMABLES'){
	    					if(this.ListPartDetails.length>0) {
	    						let chCount=0;
	    						let currentIndex;
	    						for(let ch=0;ch<this.ListPartDetails.length;ch++) {
	    							if(SRResponse[sr].Sparedetails[pt].part_Number == "" || SRResponse[sr].Sparedetails[pt].part_Number == null || SRResponse[sr].Sparedetails[pt].part_Number == undefined) {

	    							} else {
	    								if(this.ListPartDetails[ch].part_Number == SRResponse[sr].Sparedetails[pt].part_Number ) {
		    								chCount=1;
		    								currentIndex=ch;
		    							} else {

		    							}
	    							}
	    							
	    						}
	    						if(chCount == 1) {
	    							this.ListPartDetails[currentIndex].quantity += SRResponse[sr].Sparedetails[pt].quantity
	    						} else {
	    							this.ListPartDetails.push(SRResponse[sr].Sparedetails[pt]);
	    							chCount=0;
	    						}
	    					} else {
	    						this.ListPartDetails.push(SRResponse[sr].Sparedetails[pt]);
	    					}
	    					
	    				} else if(SRResponse[sr].Sparedetails[pt].cost_Type == 'SPARE COST') {
	    					if(this.ListSpareDetails.length>0) {
	    						let chCount=0;
	    						let currentIndex;
	    						if(SRResponse[sr].Sparedetails[pt].part_Number == "" || SRResponse[sr].Sparedetails[pt].part_Number == null || SRResponse[sr].Sparedetails[pt].part_Number == undefined) {

	    						} else {
	    							for(let ch=0;ch<this.ListSpareDetails.length;ch++) {
		    							if(this.ListSpareDetails[ch].part_Number == SRResponse[sr].Sparedetails[pt].part_Number ) {
		    								chCount=1;
		    								currentIndex=ch;
		    							} else {

		    							}
		    						}
	    						}
	    						
	    						if(chCount == 1) {
	    							this.ListSpareDetails[currentIndex].quantity += SRResponse[sr].Sparedetails[pt].quantity
	    						} else {
	    							this.ListSpareDetails.push(SRResponse[sr].Sparedetails[pt]);
	    							chCount=0;
	    						}
	    					} else {
	    						this.ListSpareDetails.push(SRResponse[sr].Sparedetails[pt]);
	    					}
	    					//this.ListSpareDetails.push(SRResponse[sr].Sparedetails[pt]);
						}
	    			}
	    		}
	    		this.ListFinalServiceTypeValue = [];
	    		for(let s=0;s<this.ListServiceDueDetails.length;s++) {
					console.log('servicype ', this.ListServiceDueDetails[s].service_Type)
	    			for(let st=0;st<this.ListServiceType.length;st++) {
					
	    				if(this.ListServiceDueDetails[s].service_Type == this.ListServiceType[st]._id && this.ListServiceDueDetails[s].status == 1) {
	    					this.ListFinalServiceTypeValue.push(this.ListServiceType[st].servicetype);
	    					this.ListFinalCompletedServiceType.push(this.ListServiceType[st].servicetype);
	    				} else if(this.ListServiceDueDetails[s].service_Type == this.ListServiceType[st]._id && this.ListServiceDueDetails[s].status == 0) {
	    					this.ListFinalServiceTypeValue.push(this.ListServiceType[st].servicetype);
	    				}
					}
	    		}

	    		

	    		for(let pd=0;pd<this.pieChartLabels1.length;pd++) {
	    			for(let st=0;st<this.ListServiceType.length;st++) {
	    				if(this.ListServiceType[st].servicetype == this.pieChartLabels1[pd]) {
	    					for(let s=0;s<this.ListServiceDueDetails.length;s++) {
			    				for(let ss=0;ss<SRResponse.length;ss++) {
		    						let totalValue=0;
				    				if((SRResponse[ss].serial_Number == this.ListServiceDueDetails[s].serialNumber) && (SRResponse[ss].contractLevel == this.ListServiceDueDetails[s].contractLevel)) {
										console.log('SRResponse[ss] ', SRResponse[ss] , this.ListServiceDueDetails[s].service_Scheduler_Number)
										console.log('servicype ', SRResponse[ss].Servicedetails[this.ListServiceDueDetails[s].service_Scheduler_Number-1].service_Type)
										if(this.ListServiceType[st]._id == parseInt(SRResponse[ss].Servicedetails[this.ListServiceDueDetails[s].service_Scheduler_Number-1].service_Type)){
				    						// if(SRResponse[ss].serviceScheduleDay == parseInt(this.ListServiceDueDetails[s].service_Scheduler_Number)) {
				    							totalValue =  SRResponse[ss].Servicedetails[this.ListServiceDueDetails[s].service_Scheduler_Number-1].labour_Cost || 0 + SRResponse[ss].Servicedetails[this.ListServiceDueDetails[s].service_Scheduler_Number-1].spare_Cost || 0 + SRResponse[ss].Servicedetails[this.ListServiceDueDetails[s].service_Scheduler_Number-1].travel_Cost || 0 + SRResponse[ss].Servicedetails[this.ListServiceDueDetails[s].service_Scheduler_Number-1].consumables || 0;
				    							this.piechardata1[pd] = this.piechardata1[pd] + totalValue;
				    						// }
				    					}
				    				}
		    					}
			    			}
	    				}
	    			}
	    			
	    		}

	  

				this.datavalues=[];	
				for(let i=0;i<this.pieChartLabels1.length;i++) {
					let obj={
						name:this.pieChartLabels1[i],
						percent: this.piechardata1[i] 
					}
					if(obj.percent!=0){
					this.datavalues.push(obj);
					}
				}
			this.loadingdatavalues=false;
	    		let  Servicecount = {};
	    		let ComServiceCount = {};
			    this.ListFinalServiceTypeValue.forEach(function(i) { Servicecount[i] = (Servicecount[i]||0) + 1;});
			    this.ListFinalCompletedServiceType.forEach(function(i) { ComServiceCount[i] = (ComServiceCount[i]||0) + 1;});
			    let Skey=[];
				let STvalue=[];
			    let Sarr = [];
			    Sarr.push(Servicecount);
				Sarr.forEach(function(item){
	 				for(let i in item){
						Skey.push(i);
						STvalue.push(item[i]);
				 	}
				});
				let stcount =0
				this.Svalue = [];
				for(let f=0;f<this.barChartLabels.length;f++) {
					for(let k=0;k<Skey.length;k++) {

						if(this.barChartLabels[f] == Skey[k]) {
							stcount=1;
							this.Svalue.push(STvalue[k]);
						} else {

						}
					}
					if(stcount == 0) {
			    		this.Svalue.push(0)
			    	} else {
			    		stcount=0;
			    	}
				}
				
				let SCkey=[];
				let SCTvalue=[];
			    let SCarr = [];
			    SCarr.push(ComServiceCount);
				SCarr.forEach(function(item){
	 				for(let i in item){
						SCkey.push(i);
						SCTvalue.push(item[i]);
				 	}
				});
				let stCcount =0
				this.SCvalue = [];
				for(let f=0;f<this.barChartLabels.length;f++) {
					for(let k=0;k<SCkey.length;k++) {

						if(this.barChartLabels[f] == SCkey[k]) {
							stCcount=1;
							this.SCvalue.push(SCTvalue[k]);
						} else {

						}
					}
					if(stCcount == 0) {
			    		this.SCvalue.push(0)
			    	} else {
			    		stCcount=0;
			    	}
				}




				// 'due':this.datavalue[i]-this.comdataValue[i],
				this.dataSource1=[] ;
				
				
				if(this.Svalue.length == 0 || this.SCvalue.length == 0 ) {

				} else {
					for(let i=0;i<this.barChartLabels.length;i++){
					let obj={
							"argument":this.barChartLabels[i],
							"Svalue":this.Svalue[i]-this.SCvalue[i],
							"SCvalue":this.SCvalue[i]
						}
						if(obj.Svalue!=0||obj.SCvalue!=0){
						this.dataSource1.push(obj);
						}
					}
					//console.log("dataSource1",this.dataSource1)
				}
					
                this.loadingdataSource1=false;
				this.getPieChartDetails();
			    
	    	},(err)=>{
	    		console.log(err);
	    	})
		 	
		 	

	    })
	}




	achReport() {
	//	this.loading=true;
		this.labourValues=0;
		this.partValues=0;
		this.serviceValues=0;
		this.serviceMax=0;
		this.clickACount=1;
		this.ConsumablesValue=0;
		this.TravelLabourHours=0;
		this.spedoConsumables=0;
		this.getServiceDetail();
		this.getLabourCostANDConsumables();
	}


	getServiceDetail() {
		let RequiredSDObj = {};
		if(this.clickACount == 0) {
			
			var date = new Date(), y = date.getFullYear(), m = date.getMonth();
			let firstDay = new Date(y, m, 1);
			let lastDay = new Date(y, m + 1, 0);
			

			let firstDate = moment(firstDay).format('YYYY-MM-DD');
			let lastDate = moment(lastDay).format('YYYY-MM-DD');
		  	RequiredSDObj = {
		      'fromDate': moment(firstDate).subtract(1, 'days').format('YYYY-MM-DD'),
		      'toDate':moment(lastDate).add(1, 'days').format('YYYY-MM-DD'),
		      'orgId':this.orgId
		    }
		    this.AfromDate = firstDate;
		    this.AtoDate = lastDate;
		} else if(this.clickACount == 1) {
			RequiredSDObj = {
		      'fromDate': moment(this.AfromDate).format('YYYY-MM-DD'),
		      'toDate':moment(this.AtoDate).add(1, 'days').format('YYYY-MM-DD'),
		      'orgId':this.orgId
		    }
		}
		
		
	    return this.http.post('/api/getFourMonthServiceDetailsForInactive', RequiredSDObj).subscribe(
	    res=>{ 
		
	    	let ServiceResponse = res.json();
	    	this.serviceMax = ServiceResponse.length;
	    	return this.http.post('/api/getServiceDetailsCompletedList', RequiredSDObj).subscribe(
	    	res=>{ 
	    		
	    		let SerialArr = []
	    		let ServiceCompletedResponse = res.json();
	    		this.serviceValues= ServiceCompletedResponse.length;
	    		for(let s=0;s<ServiceCompletedResponse.length;s++) {
	    			SerialArr.push(ServiceCompletedResponse[s].serialNumber)
	    		}
	    		let reqObj = {
			  		'data':SerialArr
			  	}
			  	
			  	return this.http.post('/api/getPostPonedReportBasedOnSerialNumber', reqObj).subscribe(
			    res=>{ 
			    	
			    	let SResponse = res.json();
			    	this.labourValues=0;
			    	this.ConsumablesValue=0;
			    	this.TravelLabourHours=0;
			    	this.spedoConsumables=0;
			    	if(SResponse.length>0 && ServiceCompletedResponse.length > 0) {
			    		for(let cs=0;cs<ServiceCompletedResponse.length;cs++) {
			    			for(let n=0;n<SResponse.length;n++) {
			    				if(ServiceCompletedResponse[cs].serialNumber == SResponse[n].serial_Number) {
			    					this.labourValues += SResponse[n].Servicedetails[ServiceCompletedResponse[cs].service_Scheduler_Number-1].labour_Cost || 0 + SResponse[n].Servicedetails[ServiceCompletedResponse[cs].service_Scheduler_Number-1].travel_Cost || 0;
						    		//this.labourValues = this.labourValues ? this.labourValues :0;
						    		this.TravelLabourHours += SResponse[n].Servicedetails[ServiceCompletedResponse[cs].service_Scheduler_Number-1].travel_hour || 0 + SResponse[n].Servicedetails[ServiceCompletedResponse[cs].service_Scheduler_Number-1].labour_hour || 0;
						    		
						    		let lpercentage = Math.round((this.labourValues/this.AlabourtargetValue)*100);
						    		let lactualvalue = Math.round(this.AlabourtargetValue/100);
						    		if(lpercentage <1) {
						    			this.spedoLabour = lactualvalue;
						    		} else {
						    			this.spedoLabour = this.labourValues;
						    		}
						    		this.ConsumablesValue +=  SResponse[n].Servicedetails[ServiceCompletedResponse[cs].service_Scheduler_Number-1].consumables || 0;
						    		// parseInt(SResponse[n].Servicedetails[SResponse[n].serviceScheduleDay-2].spare_Cost) +
						    		this.ConsumablesValue = this.ConsumablesValue ? this.ConsumablesValue :0;
						    		this.labourValues = this.labourValues ? this.labourValues :0;
						    		this.TravelLabourHours = this.TravelLabourHours ? this.TravelLabourHours :0;
						    		
						    		let percentage = Math.round((this.ConsumablesValue/this.AparttargetValue)*100);
						    		let actualvalue = Math.round(this.AparttargetValue/100);
						    		if(percentage <1) {
						    			this.spedoConsumables = actualvalue;
						    		} else {
						    			this.spedoConsumables = this.ConsumablesValue;
						    		}
			    				}
			    				
			    			}
			    			
				    		
						}
			    	} else {
			    		// let actualvalue = Math.round(this.AparttargetValue/100);
			    		// this.spedoConsumables = actualvalue;

			    		// let lactualvalue = Math.round(this.AlabourtargetValue/100);
			    		// this.spedoLabour = lactualvalue;
			    	}
			    	
			    })
	    	})
	    	
	    })
	}

	
	getLabourCostANDConsumables() {
		
		// let targetobj = {
		// 	'fromDate': moment(this.AfromDate).subtract(1, 'days').format('YYYY-MM-DD'),
		//     'toDate':moment(this.AtoDate).add(1, 'days').format('YYYY-MM-DD')
		// }
		this.AlabourtargetValue=0;
		this.AparttargetValue=0;
		this.AtravelLabourTargetHours=0;
		let Obj ={
			'orgId':this.orgId
		}
		return this.http.post('/api/getAllPreventiveMaintenanceDetails', Obj).subscribe(
	    res=>{ 
	    	let getTargetResponse = res.json();
	    	for(let d=0;d<getTargetResponse.length;d++) {
	    		for(let ch=0;ch<getTargetResponse[d].serviceScheduleDay;ch++){
		    		if(getTargetResponse[d].Servicedetails[ch].date >= this.AfromDate && getTargetResponse[d].Servicedetails[ch].date <= this.AtoDate) {
		    			
		    			this.AtravelLabourTargetHours +=  getTargetResponse[d].Servicedetails[ch].labour_hour + getTargetResponse[d].Servicedetails[ch].travel_hour;
		    			
		    			
		    			if((getTargetResponse[d].Servicedetails[ch].labour_Cost == null || getTargetResponse[d].Servicedetails[ch].labour_Cost == undefined) && (getTargetResponse[d].Servicedetails[ch].travel_Cost == null || getTargetResponse[d].Servicedetails[ch].travel_Cost == undefined)){

		    			} else if((getTargetResponse[d].Servicedetails[ch].labour_Cost == null || getTargetResponse[d].Servicedetails[ch].labour_Cost == undefined) && (getTargetResponse[d].Servicedetails[ch].travel_Cost !== null || getTargetResponse[d].Servicedetails[ch].travel_Cost !== undefined)) {
		    				this.AlabourtargetValue += getTargetResponse[d].Servicedetails[ch].labour_Cost;
		    			} else if((getTargetResponse[d].Servicedetails[ch].labour_Cost !== null || getTargetResponse[d].Servicedetails[ch].labour_Cost !== undefined) && (getTargetResponse[d].Servicedetails[ch].travel_Cost == null || getTargetResponse[d].Servicedetails[ch].travel_Cost == undefined)) {
		    				this.AlabourtargetValue +=  getTargetResponse[d].Servicedetails[ch].travel_Cost;
		    			} else  {
		    				this.AlabourtargetValue += getTargetResponse[d].Servicedetails[ch].labour_Cost + getTargetResponse[d].Servicedetails[ch].travel_Cost;
		    			}

		    			if(getTargetResponse[d].Servicedetails[ch].consumables == null || getTargetResponse[d].Servicedetails[ch].consumables == undefined) {

		    			} else {
		    				this.AparttargetValue += getTargetResponse[d].Servicedetails[ch].consumables;
		    				
		    			}
					}
	    		}
	    		
			}
			
	    	this.AparttargetValue = this.AparttargetValue.toFixed(2);
			this.AlabourtargetValue = this.AlabourtargetValue.toFixed(2);
			
	    })
	}
  
  


  	// doSomethingWithCurrentValue(event) {

  	// }
 
 
  	public chartClicked(e:any):void {
    	//console.log(e);
  	}
 
  	public chartHovered(e:any):void {
    	//console.log(e);
  	}

  	getPieChartDetails() {
		  
	
	  	let dataArr = [];
	  	this.LabourHours=0;
		this.TravelHours=0;
	  	this.labourCost = 0;
		this.travelCost = 0;
		this.partCost = 0;
		this.SpareCost=0;
		this.Consuamble=0;
		// this.pieChartData = [];
		// this.pieChartLabourtravelData = []
	  	for(let i=0;i<this.ListServiceDueDetails.length;i++) {
			dataArr.push(this.ListServiceDueDetails[i].serialNumber)
	  	}
	  	let Obj ={
			'orgId':this.orgId
		}
		return this.http.post('/api/getAllPreventiveMaintenanceDetails', Obj).subscribe(
	    res=>{ 
	    	
	    	let dataResponse = res.json();
			
			this.pieDataSource=[];
			this.pieChartLabels=['Labour Cost', 'Travel Cost', 'Spare Cost', 'Consumable Cost']
	    	for(let n=0;n<dataResponse.length;n++) {
	    		for(let nt=0;nt<dataResponse[n].serviceScheduleDay;nt++) {
	    			if(dataResponse[n].Servicedetails[nt].date >= this.FfromDate && dataResponse[n].Servicedetails[nt].date <= this.FtoDate) {
						if(dataResponse[n].Servicedetails[nt].labour_Cost == undefined || dataResponse[n].Servicedetails[nt].labour_Cost == null) {

						} else {
							this.labourCost += dataResponse[n].Servicedetails[nt].labour_Cost;
						}

						if(dataResponse[n].Servicedetails[nt].travel_Cost == undefined || dataResponse[n].Servicedetails[nt].travel_Cost == null) {

						} else {
							this.travelCost += dataResponse[n].Servicedetails[nt].travel_Cost;
						}

						this.SpareCost += dataResponse[n].Servicedetails[nt].spare_Cost;
						this.Consuamble += dataResponse[n].Servicedetails[nt].consumables;

						this.LabourHours += dataResponse[n].Servicedetails[nt].labour_hour;
						// console.log("labourHours " +dataResponse[n].Servicedetails[nt].labour_hour +" total"+ this.LabourHours);
						this.TravelHours += dataResponse[n].Servicedetails[nt].travel_hour;
						// console.log("travelHours " + dataResponse[n].Servicedetails[nt].travel_hour +" " + this.TravelHours)
						
						//console.log(this.labourCost, this.travelCost, this.SpareCost, this.Consuamble);
					}
	    		}
	    		
	    		
			}
			
	    	let FinalPieValue = [];
			let FinalLabourTravelValue = [];
			this.LabourTravelHours = [];
			FinalLabourTravelValue.push(this.LabourHours);
			FinalLabourTravelValue.push(this.TravelHours);
			
			for(let h=0;h<this.pieChartLabourTravelHours.length;h++) {
				let obj={
					"label":this.pieChartLabourTravelHours[h],
					"Data":FinalLabourTravelValue[h]
				}
				if(obj.Data!=0){
				this.LabourTravelHours.push(obj);
				}
			}
			this.loadingLabourTravelHours=false;
	    	FinalPieValue.push(this.labourCost.toFixed(2));
	    	FinalPieValue.push(this.travelCost.toFixed(2));
	    	FinalPieValue.push(this.SpareCost.toFixed(2));
	    	FinalPieValue.push(this.Consuamble.toFixed(2));
	    
	    	// this.pieChartData = FinalPieValue;
	    	//this.pieChartLabourtravelData=FinalLabourTravelValue;
            for(let i=0;i<this.pieChartLabels.length;i++){
             let obj={
				 "label":this.pieChartLabels[i],
				 "Data":FinalPieValue[i]
			 }
		 if(obj.Data!=0){
			 this.pieDataSource.push(obj);
		 }
			//  console.log("pieDataSource " + this.pieDataSource);
            }

this.loadingpieDataSource=false;

		})

	  }
	}


// WEBPACK FOOTER //
// ./client/app/dashboard/dashboard.component.ts